const actions = {
  FETCH_REQUEST_USER_SUBSCRIPTIONS: 'FETCH_REQUEST_USER_SUBSCRIPTIONS',
  FETCH_REQUEST_USER_SUBSCRIPTIONS_ERROR: 'FETCH_REQUEST_USER_SUBSCRIPTIONS_ERROR',
  FETCH_REQUEST_USER_SUBSCRIPTIONS_SUCCESS: 'FETCH_REQUEST_USER_SUBSCRIPTIONS_SUCCESS',
  SUBSCRIBE_TO_REQUEST_DATASET: 'SUBSCRIBE_TO_REQUEST_DATASET',
  SUBSCRIBE_TO_REQUEST_DATASET_ERROR: 'SUBSCRIBE_TO_REQUEST_DATASET_ERROR',
  SUBSCRIBE_TO_REQUEST_DATASET_SUCCESS: 'SUBSCRIBE_TO_REQUEST_DATASET_SUCCESS',
};

export default actions;
